import router from '@/router'
import AuthRoutes from './route-types.js'
import { isJwtLoginEnabled } from '@/services/featureFlags'

/**
 * Navigate to whichever login page is currently live - the Vue route or, while the flag is off,
 * the legacy WebForms page. Centralised so sign-out and every "back to login" link agree.
 *
 * Always a full navigation: App.vue runs its bootstrap once on router.onReady, so a router.push
 * here would render against stale Vuex state.
 *
 * @param {{ isSupportUser?: boolean, returnUrl?: string }} [options]
 */
export function goToLogin(options) {
  const isSupportUser = !!(options && options.isSupportUser)
  const returnUrl = options && options.returnUrl

  return isJwtLoginEnabled().then(enabled => {
    if (enabled) {
      const name = isSupportUser ? AuthRoutes.SignInCsrView.name : AuthRoutes.SignInView.name
      const resolved = router.resolve({
        name,
        query: returnUrl ? { returnUrl } : undefined
      })
      window.location.assign(resolved.href)
      return
    }

    const page = isSupportUser ? 'SignInCsr.aspx' : 'SignIn.aspx'
    window.location.href = `${process.env.VUE_APP_ROOT_URI}/${page}`
  })
}

export default { goToLogin }
